import React, { useContext, useEffect, useState } from 'react';
import { Icon } from '@legacy-vfuk/core-icon';
import Button from '@legacy-vfuk/core-button';

import { DirectionContext } from '../../contexts/DirectionContext';
import fireButtonAndLinkClicksEvent from '../../helpers/fireButtonAndLinkClicksEvent';

import UserFeedbackProps from './types/UserFeedback.types';
import {
  IconWrapper,
  NegativeFeedBackWrapper,
  PositveFeedBackWrapper,
  UserFeebackContainer,
  UserFeedbackWrapper,
} from './styles/UserFeedback.styles';

const UserFeedback = ({ feedbackConfig }: UserFeedbackProps) => {
  const ARTICLE_STORAGE_NAME = 'article-feedbacks';
  const POSITIVE_FEEDBACK = 'positive';
  const NEGATIVE_FEEDBACK = 'negative';

  const [isFeedbackGiven, setIsFeedbackGiven] = useState<boolean>(true);

  const direction = useContext(DirectionContext);

  const [allArticleFeedbacks, setAllArticleFeedbacks] = useState<{slug: string, feedback: string}[]>(
    JSON.parse(
      (typeof window !== 'undefined' &&
        window &&
        window.localStorage.getItem(ARTICLE_STORAGE_NAME)) ||
        '[]'
    )
  );

  useEffect(() => {
    const foundArticle = allArticleFeedbacks.find(({ slug }) => {
      return slug === feedbackConfig.articleSlug;
    });
    foundArticle ? setIsFeedbackGiven(true) : setIsFeedbackGiven(false);
  }, []);

  const setFeedback = (feedbackStatus: string) => {
    const articleFeedback = {
      slug: feedbackConfig.articleSlug,
      feedback: feedbackStatus,
    };
    const newArticleFeedbacks: {slug: string, feedback: string}[] = allArticleFeedbacks;
    newArticleFeedbacks.push(articleFeedback);
    setAllArticleFeedbacks(newArticleFeedbacks);
    typeof window !== 'undefined' &&
      window &&
      window.localStorage.setItem(
        ARTICLE_STORAGE_NAME,
        JSON.stringify(allArticleFeedbacks)
      );
    setIsFeedbackGiven(true);
    fireButtonAndLinkClicksEvent({
      event_label: feedbackStatus,
      event_action: 'feedback click',
      link_name: feedbackStatus === NEGATIVE_FEEDBACK ? 'dislike' : 'like',
    });
  };

  return (
    <UserFeebackContainer>
      {!isFeedbackGiven ? (
        <UserFeedbackWrapper>
          {feedbackConfig.feedbackQuestionLabel}
          <PositveFeedBackWrapper direction={direction}>
            <Button
              text={feedbackConfig.positiveFeedbackLabel}
              appearance="alt1"
              onClick={() => setFeedback(POSITIVE_FEEDBACK)}
              icon={{
                name: 'like',
                justify: 'right',
              }}
            />
          </PositveFeedBackWrapper>
          <NegativeFeedBackWrapper direction={direction}>
            <Button
              text={feedbackConfig.negativeFeedbackLabel}
              appearance="alt1"
              onClick={() => setFeedback(NEGATIVE_FEEDBACK)}
              icon={{
                name: 'dislike',
                justify: 'right',
              }}
            />
          </NegativeFeedBackWrapper>
        </UserFeedbackWrapper>
      ) : (
        <UserFeedbackWrapper>
          {feedbackConfig.feedbackThanksLabel}
          <IconWrapper direction={direction}>
            <Icon name="tick-outline" />
          </IconWrapper>
        </UserFeedbackWrapper>
      )}
    </UserFeebackContainer>
  );
};

export default UserFeedback;
